var map = {
	"./food_candy.jpg": "b517",
	"./food_mosaic.jpg": "2966",
	"./food_original.jpg": "f856",
	"./food_rain.jpg": "b1a0",
	"./food_udnie.jpg": "97cf",
	"./foot_candy.jpg": "ef5b",
	"./foot_mosaic.jpg": "f82a",
	"./foot_original.jpg": "349a",
	"./foot_rain.jpg": "8d05",
	"./foot_udnie.jpg": "ba98",
	"./tower_candy.jpg": "aeff",
	"./tower_mosaic.jpg": "4465",
	"./tower_original.jpg": "59ab",
	"./tower_rain.jpg": "2608",
	"./tower_udnie.jpg": "b948"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "62f2";